import { IMovementScheduleFli } from '@modeso/types__aumico-lib-annualreport-be';

export interface IMovementSchedulePrintPreview {
    currentMovementScheduleFlis: IMovementScheduleFli[];
    previousFlisOfCurrentFlis: Map<number, IMovementScheduleFli>;
}
